import React from 'react';
import { ReactComponent as Success } from '@/assets/images/svg/success.svg';
import { Button } from '@/components';
import { ProducerLink } from '@/model/ProducerLink';

export interface StateProps {
  producerLink?: ProducerLink;
}

export interface DispatchProps {
  onCopyLink: (url: string) => void;
}

type Props = StateProps & DispatchProps;

export const CopyProducerProductLinkScreen: React.FC<Props> = ({
  producerLink,
  onCopyLink,
}): JSX.Element => (
  <div className="filter-modal-content">
    <div className="exclude-container">
      <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
        <Success color="#E64F49" style={{ width: 40 }} />{' '}
        <h5 className="modal__confirmation-title">O Link foi gerado com sucesso</h5>
      </div>
      <div
        className="modal__confirmation-text"
        style={{ display: 'flex', alignItems: 'center', gap: '5px', marginBottom: '20px' }}
      >
        <h6 style={{ maxWidth: '300px', marginRight: '20px' }}>
          Para copiar o link, click no <strong>Botão</strong> abaixo.
        </h6>
      </div>
      {producerLink && producerLink.url && (
        <>
          <div>
            Para copiar o link, click sobre o <strong>link</strong> abaixo.
          </div>
          <div>
            <a href={producerLink.url} target="_blank" rel="noopener noreferrer">
              {producerLink.url}
            </a>
          </div>
          <div style={{ marginTop: '30px' }}>
            <Button title="Copiar Link" onClick={() => onCopyLink(producerLink.url)} />
          </div>
        </>
      )}
    </div>
  </div>
);
